export enum FeatureKeyEnum {
    Dashboard = 'dashboard',
    Products = 'products',
    ProductEpcRegistration = 'product_epc_registration',
    ProductEpcManualStatus = 'product_epc_manual_status',
    EanRegistrationChicdeal = 'ean_registration_chicdeal',
    Promotions = 'promotions',
    Vouchers = 'vouchers',
    LineDiscounts = 'line_discounts',
    EmployeeDiscounts = 'employee_discounts',
    Operators = 'operator_login',
    Transactions = 'sale_transaction',
    SalesOverview = 'sales_overview',
    TruckReport = 'truck_report',
    TaggingAttendance = 'tagging_attendance',
    LiveStore = 'live_store',
    LiveWarehouse = 'live_warehouse',
    WarehouseAnalysis = 'warehouse_analysis',
    StoreAnalysis = 'store_analysis',
    AntennaMonitoring = 'antenna_monitoring',
    ApiTokens = 'api_tokens',
    Hooks = 'hooks',
    Locations = 'locations',
    Statistics = 'statistics',
    SystemLogs = 'system_logs',
    Warehouse = 'warehouse',
    Settings = 'settings',
    Inventory = 'inventory',
    CompanyAdminHookLogs = 'companyadmin-hook-logs',
    CompanyAdminExternalApiLogs = 'companyadmin-external-api-logs',
    CompanyAdminAntennaStatsLogs = 'companyadmin-antenna-stats-logs',
    CompanyAdminEpcReadingLogs = 'companyadmin-epc-reading-logs',
    CompanyAdminWarehouseNodeEpcLogs = 'companyadmin-warehouse-node-epc-logs',
    EanRegistry = 'ean_registry',
    CashRegisters = 'cash_registers',
    PackingStations = 'packing_stations',
    Printers = 'printers',
    Devices = 'devices',
    PaymentConfigurations = 'payment_configurations',
    ErosConfigurations = 'eros_configurations',
    PriceTemplates = 'price_templates',
    AiChat = 'ai_chat',
    Insights = 'insights',
    RoiCalculator = 'roi_calculator',
    PisnerRoi = 'pisner_roi',
    RfidBuilder = 'rfid_builder',
    RetailFocused = 'retail_focused',
    LogisticsFocused = 'logistics_focused',
    ManufacturingFocused = 'manufacturing_focused',
    Workers = 'workers',
    StockIn = 'stock_in',
    StockOut = 'stock_out',
    Packages = 'packages',
    WasteCollection = 'waste_collection',
    WasteCollectionPhotoCheck = 'waste_collection_photo_check',
    SortingTests = 'sorting_tests',
}
